"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineEERDisplayMode = void 0;
function determineEERDisplayMode(lastMinuteSeerRating) {
    const airHandlerAmperage = lastMinuteSeerRating?.airHandlerAvgAmperage ?? 0;
    const condenserAmperage = lastMinuteSeerRating?.condenserAvgAmperage ?? 0;
    const airHandlerDataPoints = lastMinuteSeerRating?.airHandlerDataPoints ?? 0;
    const condenserDataPoints = lastMinuteSeerRating?.condenserDataPoints ?? 0;
    const hasAirHandlerData = airHandlerDataPoints > 0;
    const hasCondenserData = condenserDataPoints > 0;
    const hasAmperageData = hasAirHandlerData || hasCondenserData;
    const isAirHandlerOn = airHandlerAmperage > 0;
    const isCondenserOn = condenserAmperage > 0;
    let mode;
    if (hasAmperageData &&
        !isAirHandlerOn &&
        !isCondenserOn &&
        (hasAirHandlerData || hasCondenserData)) {
        mode = 'off';
    }
    else if (((!hasAirHandlerData || !isAirHandlerOn) && isCondenserOn) ||
        ((!hasCondenserData || !isCondenserOn) && isAirHandlerOn)) {
        mode = 'peak';
    }
    else {
        mode = 'instant';
    }
    return {
        mode,
        airHandlerAmperage,
        condenserAmperage,
        hasAmperageData,
    };
}
exports.determineEERDisplayMode = determineEERDisplayMode;
